import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import { grey, purple } from '@material-ui/core/colors';
import { ProgressBarWrapper } from './styles';

const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    backgroundColor: grey[50],
    borderRadius: 20,
  },
  bar: {
    animationName: '$slidingBackgroundAnimation',
    animationDuration: '1s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    borderRadius: 20,
    backgroundImage: `-webkit-linear-gradient(45deg, transparent, transparent 33%, rgba(142, 36, 170, .1) 33%, rgba(142, 36, 170, .1) 66%, transparent 66%),-webkit-linear-gradient(top, rgba(255, 255, 255, .5), rgba(142, 36, 170, .3)),-webkit-linear-gradient(left, ${purple[600]}, ${purple[300]})`,
    backgroundSize: '25px 14px, 100% 100%, 100% 100%',
  },
  '@keyframes slidingBackgroundAnimation': {
    '0%': {
      backgroundPositionX: '25px',
    },
    '100%': {
      backgroundPositionX: '0',
    },
  },
})(LinearProgress);

const ProgressBar = ({ value }) => (
  <ProgressBarWrapper>
    <BorderLinearProgress variant="determinate" color="secondary" value={value} />
  </ProgressBarWrapper>
);

ProgressBar.defaultProps = {
  value: 0,
};

ProgressBar.propTypes = {
  value: PropTypes.number,
};

export default ProgressBar;
